// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"972a7c12","767":"e823892d","829":"f490868d"}[chunkId] + ".chunk.css";
};